import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITaskProgress, TaskModel, TaskProgressModel } from '@atlas-workspace/shared/models';
import { environment } from '@environment-client';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IOutputTaskInformation, IResponseTaskInformation } from '../interface/response-task-information';

/* eslint-disable */

interface ITaskParams {
  page: string;
  per_page: string;
  filter_by_is_done?: string;
}

@Injectable({ providedIn: 'root' })
export class TasksService {
  constructor(private http: HttpClient) {}

  getTasksProgress(unitId: number): Observable<TaskProgressModel> {
    return this.http
      .get<{ data: ITaskProgress }>(environment.apiBaseUrl + '/api/v1/tasks_progress', {
        params: {
          unit_id: unitId.toString(),
        },
      })
      .pipe(map(({ data }) => plainToClass(TaskProgressModel, data)));
  }

  getListOfTasks(
    unitId: number,
    status: boolean | undefined,
    search = '',
    sort = 'default',
    page: number = 1,
    perPage: number = 50
  ): Observable<IOutputTaskInformation> {
    const taskParams: ITaskParams | any = {
      page: page.toString(),
      per_page: perPage.toString(),
      search,
      sort_by: sort,
    };

    if (status !== undefined) {
      taskParams.filter_by_is_done = status.toString();
    }

    return this.http
      .get<IResponseTaskInformation>(environment.apiBaseUrl + `/api/v1/client/units/${unitId}/tasks`, {
        params: {
          ...taskParams,
        },
        observe: 'response',
      })
      .pipe(
        map((response) => {
          const { body, headers } = response;
          const totalPages = headers.get('total-pages');
          const totalCount = headers.get('total-count');
          return { ...body, totalPages, totalCount };
        }),
        map(({ data, totalPages, totalCount }) => {
          return {
            listOfTasks: plainToClass(TaskModel, data!.unit_tasks),
            totalPages,
            totalCount,
          };
        })
      );
  }

  toggleTaskStatus(unitId: string | number | undefined, taskId: number, isDone: boolean): Observable<TaskModel> {
    return this.http
      .put(environment.apiBaseUrl + `api/v1/units/${unitId}/tasks/${taskId}/task_status`, {
        task_status: {
          is_done: isDone,
        },
      })
      .pipe(
        map((res: any) => res.data),
        map((task) => plainToClass(TaskModel, task))
      );
  }

  getTask(projectId: number, id: number): Observable<TaskModel> {
    return this.http.get(environment.apiBaseUrl + `/api/v1/projects/${projectId}/tasks/${id}`).pipe(
      map((res: any) => res.data),
      map((task) => plainToClass(TaskModel, task))
    );
  }
}
